import { LayerType, Layer, AccessMethod, LayerGroup, BgLayerSubGroup } from '../model/layer/layer';

// svenske kartlag fra lantmäteriet
export const swedishLayerIdsLantmateriet = ['sverige_nedtonad', 'sverige', 'sverige_orto'];

// norske kartlag fra kartverket
export const norwegianLayerIdsKartverket = ['norge_graatone', 'norge'];

export type MapLayerProviderForToggles = 'lantmateriet' | 'kartverket';

export const layers: Layer[] = [
    {
        id: 'norge_graatone',
        group: LayerGroup.BG,
        subGroup: BgLayerSubGroup.graatone,
        type: LayerType.WMTS,
        access: AccessMethod.NONE,
        urls: ['https://cache.kartverket.no/v1/service?service=WMTS&request=GetCapabilities'],
        params: {
            LAYERS: 'topograatone',
            TILED: true,
            FORMAT: 'image/png',
            VERSION: '1.0.0',
            TILEMATRIXSET: 'utm33n',
            PROJECTION: 'EPSG:25833',
        },
        options: {
            attribution: 'Statens kartverk',
            zIndex: 11,
            visible: true,
        },
    },
    {
        id: 'sverige_nedtonad',
        group: LayerGroup.BG,
        subGroup: BgLayerSubGroup.graatone,
        type: LayerType.WMTS,
        access: AccessMethod.MAPP,
        urls: [
            'https://rovbase-mapproxy.p.aks.miljodirektoratet.no/api/proxy/sverige_wmts?request=GetCapabilities&service=wmts',
        ],
        tileUrl: 'https://rovbase-mapproxy.p.aks.miljodirektoratet.no/api/proxy/sverige_wmts?',
        params: {
            LAYERS: 'topowebb_nedtonad',
            TILED: true,
            FORMAT: 'image/png',
            PROJECTION: 'EPSG:3857',
        },
        options: {
            attribution: 'Lantmäteriet',
            zIndex: 10,
            visible: true,
        },
    },
    {
        id: 'norge',
        group: LayerGroup.BG,
        subGroup: BgLayerSubGroup.topo,
        type: LayerType.WMTS,
        access: AccessMethod.NONE,
        urls: ['https://cache.kartverket.no/v1/service?service=WMTS&request=GetCapabilities'],
        params: {
            LAYERS: 'topo',
            TILED: true,
            FORMAT: 'image/png',
            VERSION: '1.0.0',
            TILEMATRIXSET: 'utm33n',
            PROJECTION: 'EPSG:25833',
        },
        options: {
            attribution: 'Statens kartverk',
            zIndex: 10,
            visible: false,
        },
    },
    {
        id: 'sverige',
        group: LayerGroup.BG,
        subGroup: BgLayerSubGroup.topo,
        type: LayerType.WMTS,
        access: AccessMethod.MAPP,
        urls: [
            'https://rovbase-mapproxy.p.aks.miljodirektoratet.no/api/proxy/sverige_wmts?request=GetCapabilities&service=wmts',
        ],
        tileUrl: 'https://rovbase-mapproxy.p.aks.miljodirektoratet.no/api/proxy/sverige_wmts?',
        params: {
            LAYERS: 'topowebb',
            TILED: true,
            FORMAT: 'image/png',
            PROJECTION: 'EPSG:3857',
        },
        options: {
            attribution: 'Lantmäteriet',
            zIndex: 9,
            visible: false,
        },
    },
    {
        id: 'norgeibilder',
        group: LayerGroup.BG,
        subGroup: BgLayerSubGroup.orto,
        type: LayerType.WMTS,
        access: AccessMethod.NONE,
        urls: [
            'https://services.geodataonline.no/arcgis/rest/services/Geocache_UTM33_WGS84/GeocacheBilder/MapServer/WMTS/1.0.0/WMTSCapabilities.xml',
        ],
        params: {
            LAYERS: 'Geocache_UTM33_WGS84_GeocacheBilder',
            FORMAT: 'image/png',
            BLANKTILE: false,
        },
        options: {
            attribution: 'Geodata AS, Kartverket, Geovekst og kommunene',
            zIndex: 11,
            visible: false,
        },
    },
    {
        id: 'sverige_orto',
        group: LayerGroup.BG,
        subGroup: BgLayerSubGroup.orto,
        type: LayerType.WMS,
        access: AccessMethod.MAPP,
        urls: ['https://rovbase-mapproxy.p.aks.miljodirektoratet.no/api/proxy/sverige_orto'],
        params: {
            LAYERS: 'Ortofoto_0.5',
            TILED: true,
            FORMAT: 'image/jpeg',
            VERSION: '1.1.1',
        },
        options: {
            attribution: 'Lantmäteriet',
            zIndex: 10,
            visible: false,
        },
    },
    {
        id: 'ulv',
        type: LayerType.WMS,
        access: AccessMethod.NONE,
        urls: ['https://kart.miljodirektoratet.no/geoserver/forvaltningsomrader_rovdyr/wms'],
        params: {
            LAYERS: 'ulv_forvaltningsomrade',
            FORMAT: 'image/png',
            TRANSPARENT: true,
        },
        options: {
            attribution: 'Miljødirektoratet',
            zIndex: 15,
            visible: false,
        },
    },
    {
        id: 'bjorn',
        type: LayerType.WMS,
        access: AccessMethod.NONE,
        urls: ['https://kart.miljodirektoratet.no/geoserver/forvaltningsomrader_rovdyr/wms'],
        params: {
            LAYERS: 'bjorn_forvaltningsomrade',
            FORMAT: 'image/png',
            TRANSPARENT: true,
        },
        options: {
            attribution: 'Miljødirektoratet',
            zIndex: 15,
            visible: false,
        },
    },
    {
        id: 'jerv',
        type: LayerType.WMS,
        access: AccessMethod.NONE,
        urls: ['https://kart.miljodirektoratet.no/geoserver/forvaltningsomrader_rovdyr/wms'],
        params: {
            LAYERS: 'jerv_forvaltningsomrade',
            FORMAT: 'image/png',
            TRANSPARENT: true,
        },
        options: {
            attribution: 'Miljødirektoratet',
            zIndex: 15,
            visible: false,
        },
    },
    {
        id: 'gaupe',
        type: LayerType.WMS,
        access: AccessMethod.NONE,
        urls: ['https://kart.miljodirektoratet.no/geoserver/forvaltningsomrader_rovdyr/wms'],
        params: {
            LAYERS: 'gaupe_forvaltningsomrade',
            FORMAT: 'image/png',
            TRANSPARENT: true,
        },
        options: {
            attribution: 'Miljødirektoratet',
            zIndex: 15,
            visible: false,
        },
    },
    {
        id: 'reinbeite_omr',
        type: LayerType.WMS,
        access: AccessMethod.NONE,
        urls: ['https://kart.miljodirektoratet.no/geoserver/wms?Service=wms&'],
        params: {
            LAYERS: 'reinbeite_omrade',
            FORMAT: 'image/png',
            TRANSPARENT: true,
        },
        options: {
            attribution: 'Miljødirektoratet',
            zIndex: 18,
            visible: false,
        },
    },
    {
        id: 'reinbeite_distr',
        type: LayerType.WMS,
        access: AccessMethod.NONE,
        urls: ['https://kart.miljodirektoratet.no/geoserver/wms?Service=wms&'],
        params: {
            LAYERS: 'reinbeitedistrikt_omrade',
            FORMAT: 'image/png',
            TRANSPARENT: true,
        },
        options: {
            attribution: 'Miljødirektoratet',
            zIndex: 17,
            visible: false,
        },
    },
    {
        id: 'beitelaggrenser',
        type: LayerType.WMS,
        access: AccessMethod.NONE,
        urls: ['https://wms.nibio.no/cgi-bin/beite'],
        params: {
            LAYERS: 'Beitelaggrenser',
            FORMAT: 'image/png',
            TRANSPARENT: true,
        },
        options: {
            attribution: 'NIBIO',
            zIndex: 15,
            visible: false,
        },
    },
    {
        id: 'beitelagnamn',
        type: LayerType.WMS,
        access: AccessMethod.NONE,
        urls: ['https://wms.nibio.no/cgi-bin/beite'],
        params: {
            LAYERS: 'Beitelagnamn',
            FORMAT: 'image/png',
            TRANSPARENT: true,
        },
        options: {
            attribution: 'NIBIO',
            maxResolution: 170,
            zIndex: 15,
            visible: false,
        },
    },
    {
        id: 'samebygrenser',
        type: LayerType.VECTOR,
        access: AccessMethod.NONE,
        urls: ['/api/samebygrenser'],
        options: {
            zIndex: 16,
            visible: false,
        },
    },
];
